"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  id: "faq-1",
  number: "01",
  question: "What are the current mortgage interest rates?",
  answer: <>
        Our rates are updated daily to reflect the market. You can view our current estimates for{" "}
        <Link to="/LendingSolutionsPage" className="text-primary hover:underline font-medium">
          Fixed-Rate Mortgages
        </Link>{" "}
        and{" "}
        <Link to="/LendingSolutionsPage" className="text-primary hover:underline font-medium">
          Adjustable-Rate Loans
        </Link>
        . Contact a Beacon advisor for a personalized quote based on your credit profile.
      </>
}, {
  id: "faq-2",
  number: "02",
  question: "How much do I need for a down payment?",
  answer: <>
        While 20% is the traditional standard, Beacon Finance Group offers several programs that allow for down payments as low as 3% for qualified first-time homebuyers. We also specialize in VA loans which may require 0% down for eligible veterans.
      </>
}, {
  id: "faq-3",
  number: "03",
  question: "What is the difference between pre-qualification and pre-approval?",
  answer: <>
        Pre-qualification is an informal estimate of your borrowing power. Pre-approval is a formal commitment from Beacon Finance Group after we verify your financial documentation, giving you a significant advantage when making an offer on a home.
      </>
}, {
  id: "faq-4",
  number: "04",
  question: "Can I refinance my current mortgage to a lower rate?",
  answer: <>
        Absolutely. Refinancing can help lower your monthly payments, shorten your loan term, or allow you to tap into your home's equity. Our advisors can perform a "Break-Even Analysis" to see if refinancing makes financial sense for your specific situation.
      </>
}, {
  id: "faq-5",
  number: "05",
  question: "How long does the closing process typically take?",
  answer: <>
        At Beacon, we pride ourselves on efficiency. While the industry average is often 45-60 days, our streamlined digital application and dedicated local processing team aim to close most residential loans within 21 to 30 days.
      </>
}];
export default function CommonQuestions() {
  return <section data-section-id="234921" id="common-questions" className="relative w-full bg-background text-foreground py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
      backgroundSize: '2rem 2rem'
    }} aria-hidden="true" />

      <div className="container mx-auto px-4 md:px-6 max-w-4xl relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary mb-4">
            Common Questions
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto font-default">
            Navigating the mortgage process can be complex. We've compiled answers to the most frequent inquiries to provide you with guided clarity.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-6">
          {faqs.map((faq, i) => <AccordionItem key={faq.id} value={faq.id} data-index={i} className="border-2 border-muted bg-card/50 backdrop-blur-sm rounded-md overflow-hidden transition-all duration-300 data-[state=open]:border-primary/30 data-[state=open]:bg-card shadow-md">
              <AccordionTrigger className="px-6 py-6 hover:bg-accent/50 hover:no-underline group">
                <div className="flex items-center gap-6 text-left w-full pr-4">
                  <span className="text-5xl md:text-6xl font-mono font-bold text-transparent [-webkit-text-stroke:1px_var(--color-primary)] opacity-20 group-hover:opacity-40 transition-opacity select-none shrink-0">
                    {faq.number}
                  </span>
                  <span className="font-default text-lg md:text-xl font-bold text-primary group-hover:text-primary/80 transition-colors">
                    {faq.question}
                  </span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-8 pt-2">
                <div className="pl-[5.5rem] md:pl-[6.5rem]">
                  <p className="text-base text-foreground/80 leading-relaxed font-default">
                    {faq.answer}
                  </p>
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}